import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import * as S from './HeaderNotification.styles';
import { Popup } from '@/components/UI/Popup/Popup';
import { useToggleOpenState } from '@/hooks/useToggleOpenState';
import { Button } from '@/components/UI/Button/Button';

export const HeaderNotification = () => {
  const { t } = useTranslation();
  const [isOpen, toggle] = useToggleOpenState();

  return (
    <>
      <S.Box onClick={toggle}>
        <div>
          <S.Title $variant="2">{t('common.attention')}</S.Title>
          <S.Text $variant="3">
            {t('pages.cabinet.business_notification_description')}
          </S.Text>
        </div>

        <Button appearance="secondaryOutlined" size="s">
          {t('common.more_details')}
        </Button>
      </S.Box>

      <Popup
        isOpen={isOpen}
        close={toggle}
        isInPortal
        title={t('pages.cabinet.updates_in_packages')}
        description={
          <>
            <S.Paragraph>
              <Trans i18nKey="pages.cabinet.business_notification_popup_content" />
            </S.Paragraph>
          </>
        }
        actions={{ left: { text: t('common.got_it'), onClick: toggle } }}
      />
    </>
  );
};
